import { render, staticRenderFns } from "./Obfuscation.vue?vue&type=template&id=415d7f19&"
import script from "./Obfuscation.vue?vue&type=script&lang=ts&"
export * from "./Obfuscation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports